import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Dashboard from "@/pages/dashboard";
import POExcelManagement from "@/pages/po-excel-management";
import POValidation from "@/pages/po-validation";
import PODetail from "@/pages/po-detail";
import Settings from "@/pages/settings";
import Onboarding from "@/pages/onboarding";
import AuditLogs from "@/pages/audit-logs";
import LoginPage from "@/pages/loginpage";
import AppLayout from "@/components/layout/AppLayout";
import { UserProvider } from "@/contexts/UserContext";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import RoleDashboard from "./pages/role-dashboard";
import UserInvite from "./pages/invite-screen";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setUser } from "./store/slices/userSlice";
import { useSelector } from "react-redux";
import BASE_URL from "./constants";
import LandingPage from "./pages/landing-page";
axios.defaults.withCredentials = true

// Check if the user has completed onboarding

const hasCompletedOnboarding = () => {
  return localStorage.getItem("onboarding") === "true";
};

function Router() {
  const [location, setLocation] = useLocation();
  const user = useSelector((state: any) => state.user.user_name);
  const [isOnboarded, setIsOnboarded] = useState(hasCompletedOnboarding());
  const dispatch = useDispatch();
  useEffect(() => {
    // Update onboarding status when localStorage changes
    const checkOnboarding = () => {
      setIsOnboarded(hasCompletedOnboarding());
    };

    window.addEventListener("storage", checkOnboarding);
    return () => window.removeEventListener("storage", checkOnboarding);
  }, []);

  // If not onboarded and not currently on onboarding page, redirect to onboarding
  // useEffect(() => {
  //   if (
  //     !isOnboarded &&
  //     location !== "/onboarding" &&
  //     location !== "/login"
  //   ) {
  //     window.location.href = "/onboarding";
  //   }
  // }, [isOnboarded, location]);

  const checkSession = async () => {
  const isInviteRoute = /^\/po-user-invite\/[^/]+$/.test(location);
  const isLandingPage = location === "/";

  if (isInviteRoute || isLandingPage) return;

  try {
    const response = await axios.get(BASE_URL + "/users/refresh");
    const { company_name, isManager, role, email: userEmail, name } = response.data;
    dispatch(
      setUser({
        company_name,
        isManager,
        role,
        email: userEmail,
        name,
      })
    );
  
  } catch (error) {
    setLocation("/login");
  }
};


useEffect(() => {
  if (!user) {
    const timeout = setTimeout(() => {
      checkSession();
    }, 100);

    return () => clearTimeout(timeout); // Correct cleanup function
  }
}, []);


// const cleanupFunction = useEffect(useCallback,[])

console.log(
  `%c 🚀 Welcome to the Application! 
%c Crafted with ❤️ by the developers at Nuvoretail.
%c Let's build something great together. 💡`,
  "font-size: 16px; font-weight: bold; color: #6366f1;",
  "font-size: 14px; color: #10b981;",
  "font-size: 12px; color: #6b7280;"
);



  return (
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/onboarding" component={Onboarding} />
      {/* <Route path="/po-management" component={POExcelManagement} /> */}
      <Route path="/" component={LandingPage} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/po-validation" component={POValidation} />
      <Route path="/settings" component={Settings} />
      <Route path="/po/:id" component={PODetail} />
      <Route path="/role/:role" component={RoleDashboard} />
      <Route path="/po-user-invite/:userId" component={UserInvite} />

      <Route path="/audit-logs" component={AuditLogs} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const [location] = useLocation();
  const isOnboardingPage = location === "/onboarding";
  const isLoginPage = location === "/login";
  const isInvitePage = /^\/po-user-invite\/[^/]+$/.test(location);
  const isLandingPage = location === "/";

  const noLayoutNeeded = isOnboardingPage || isLoginPage || isInvitePage || isLandingPage;

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <TooltipProvider>
            {noLayoutNeeded ? (
              <Router />
            ) : (
              <AppLayout>
                <Router />
              </AppLayout>
            )}
            <Toaster />
          </TooltipProvider>
        </UserProvider>
      </QueryClientProvider>
    </Provider>
  );
}


export default App;
